import { useNavigate } from 'react-router';

let navigator = null;
export const getNavigator = () => navigator;

const Navigator = ({children}) => {
  navigator = useNavigate();
  return <>{children}</>
};
export default Navigator;